import { CraAttributeName, TreatmentType, Score } from "@keita/lanepatrol-sdk";
import { CraAttributeFilter, ScoreFilters } from "../../map/models/MapFilters";
import { Treatment } from "../../cra/models/CraNode";
import { ScoreImpact } from "../../coding/models/ScoreImpact";

type wayAndNodeId = string;

export interface CraForecastScenario {
  id: string;
  surveyId: string;
  name: string;
  actions: CraForecastAction[];
  createdAt: string;
  createdById: string;
}

export interface CraForecastActionRequest {
  change: CraForecastChange;
  filters: CraForecastFilters;
}

export interface CraForecastFilters {
  craWayFilters: string[];
  scoreFilters: ScoreFilters;
  treatmentFilters: TreatmentType[];
  attributeFilters: CraAttributeFilter[];
}

export interface CraForecastAction extends CraForecastActionRequest {
  results?: Map<wayAndNodeId, CraSimulatedResult>;
}

export type CraForecastChange =
  | {
      type: CraForecastChangeType.HighestPriorityTreatment;
    }
  | {
      type: CraForecastChangeType.TreatmentWhenSuggested;
      treatmentType: TreatmentType;
    }
  | {
      type: CraForecastChangeType.AttributeValues;
      attributeValues: { [key in CraAttributeName]?: string };
    };

export enum CraForecastChangeType {
  HighestPriorityTreatment = "HighestPriorityTreatment",
  TreatmentWhenSuggested = "TreatmentWhenSuggested",
  AttributeValues = "AttributeValues",
}

export interface CraSimulatedResult {
  score: Score;
  scoreImpact: ScoreImpact;
  treatments: Treatment[];
}

export interface CreateCraForecastScenarioRequest {
  surveyId: string;
  name: string;
  actions: CraForecastActionRequest[];
}

export interface UpdateCraForecastScenarioRequest {
  name: string;
  actions: CraForecastActionRequest[];
}
